import React, { memo } from 'react';

interface Props {
    className?: string;
    color?: string;
}

function Check4Icon({ className, color }: Props) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="12" fill={color || "#50B8E7"} />
            <path
                d="M13.4 17V13.5H14.8V12H13.4V7.5H11.7L7.7 12V13.5H11.9V17H13.4ZM9.7 12L12 9.2V12H9.7Z"
                fill="white"
            />
        </svg>
    );
}

export default memo(Check4Icon);
